import React from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import Layout from "../../components/layout";
import CatClubConfig from "../../components/catClubConfig";

interface Props {
  userContext: { clubSessionId: any };
}

class CatClubConfigPage extends React.Component<Props> {
  render() {
    return (
      <main>
        <Helmet title="Reporte preliminar de CAT" />
        <Layout>
          <CatClubConfig userContext={this.props.userContext} />
        </Layout>
      </main>
    );
  }
}

const mapStateToProps = ({ user }) => {
  return {
    userContext: user.userContext
  };
};

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CatClubConfigPage);
